import * as Yup from 'yup'

export interface ISalesTableSchema {
    realEstateId: string
    tableDate: string
    name: string
}

const salesTableSchema: Yup.SchemaOf<ISalesTableSchema> = Yup.object().shape({
    tableDate: Yup.string().required('Preenchimento obrigatório.'),
    name: Yup.string().required('Nome da tabela de vendas é obrigatório.'),
    realEstateId: Yup.string().notOneOf(['none'], 'Selecione o imóvel.').required('Selecione o imóvel.'),
})

export default salesTableSchema
